var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["onlineListener"]: () => (__WEBPACK_EXTERNAL_MODULE_online_listener_190b5551__.onlineListener) });